import { getCurrentUser } from '@/utils/index';

const PREVIEW_USERNAMES = new Set(['aim120', 'aimtest10']);

export function isUgcReelPreviewUser(user = getCurrentUser()) {
  return PREVIEW_USERNAMES.has(String((user && user.un) || '').trim().toLowerCase());
}
